import {
  Component,
  computed,
  forwardRef,
  inject,
  input,
  OnDestroy,
  OnInit,
  signal
} from '@angular/core';
import {AudienceParams} from "../../../../../../types/records-table.types";
import {BloggerProfileDialogData} from "../../../types/blogger-modal.types";
import {getDefaultAudienceParams} from "../../../../../../models/default-audience-params";
import {defaultRecordPropertyData} from "../../../../../../models/default-record-property-data";
import {bloggerModalResources, BloggerModalResourceType} from "../../../../../../models/resource/tables/blogger-modal-resource-type";
import {
  WrapperElementSizeStateService
} from "../../../../../../services/table-services/wrapper-element-size-state.service";
import {ColumnParamsStateService} from "../../../../../../services/table-services/column-params-state.service";
import {
  defaultSortBloggerProfileTables
} from "../../../configs/blogger-profile-tables-config";
import {AudiencePanelConfig} from "../../../types/blogger-profile-tables.types";
import {
  AudienceAgeCardComponent
} from "../../../../edit-audience-modal/components/audience-age-card/audience-age-card.component";
import {
  AudienceGeoCardComponent
} from "../../../../edit-audience-modal/components/audience-geo-card/audience-geo-card.component";
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from "@angular/material/expansion";
import {NgComponentOutlet} from "@angular/common";
import {RecordsTableContainerComponent} from "../../../../../records-table-container/records-table-container.component";
import {GetRecordPropertyDataByIdParams} from "../../../../base-modal/types/base-modal.types";
import {BloggerModalService} from "../../../services/blogger-modal.service";

@Component({
  selector: 'app-blogger-profile-tables',
  standalone: true,
  imports: [
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    NgComponentOutlet,
    RecordsTableContainerComponent,
    forwardRef(() => RecordsTableContainerComponent)
  ],
  templateUrl: './blogger-profile-tables.component.html',
  styleUrl: './blogger-profile-tables.component.scss'
})
export class BloggerProfileTablesComponent implements OnInit, OnDestroy {
  bloggerDialogData = input.required<BloggerProfileDialogData>();

  private wrapperElementSizeStateService: WrapperElementSizeStateService = inject(WrapperElementSizeStateService);
  private columnParamsStateService: ColumnParamsStateService = inject(ColumnParamsStateService);
  private bloggerModalService: BloggerModalService = inject(BloggerModalService);

  public readonly bloggerModalResourcesKeys = Object.keys(bloggerModalResources) as Array<BloggerModalResourceType>;
  public readonly bloggerModalResources = bloggerModalResources;
  public audienceParams = signal<AudienceParams | null>(null);
  public bloggerId = computed(() => this.bloggerDialogData().bloggerId)
  private audienceId = computed(() => this.bloggerDialogData().audienceId || 0);

  public async ngOnInit() {
    await this.loadAudienceParams();
  }

  public ngOnDestroy() {
    this.bloggerModalResourcesKeys.forEach((key: string) => {
      this.wrapperElementSizeStateService.resetSpecificWrapperElementSize(key);
      this.columnParamsStateService.resetTableColumnParamsState(key);
    });
  }

  public getTableSort(key: string): Array<string> {
    return defaultSortBloggerProfileTables.find(i => i.key === key)?.sort || [ 'id,desc' ];
  }

  public createAudiencePanelsConfig(audienceParams: AudienceParams | null): Array<AudiencePanelConfig<AudienceAgeCardComponent | AudienceGeoCardComponent>> {
    return audienceParams ?
      [
        {
          title: 'Возраст аудитории',
          component: AudienceAgeCardComponent,
          expanded: true,
          inputs: {
            audienceParams: audienceParams,
            isEditEnabled: false
          }
        },
        {
          title: 'Геоположение аудитории',
          component: AudienceGeoCardComponent,
          expanded: true,
          inputs: {
            audienceParams: audienceParams,
            isEditEnabled: false
          }
        }
      ] :
      [];
  }

  private async loadAudienceParams(): Promise<void> {
    if (!this.audienceId()) {
      this.audienceParams.set(getDefaultAudienceParams());
      return;
    }

    const params: GetRecordPropertyDataByIdParams = {
      path: 'audiences',
      resourceId: this.audienceId()
    };

    await this.bloggerModalService.getRecordPropertyDataById<AudienceParams>(params)
      .then((data) => this.audienceParams.set(data))
      .catch(() => this.audienceParams.set(defaultRecordPropertyData as AudienceParams));
  }
}
